export const API_URL = getAPIURL();
export const API_USER_SERVICE = 'http://localhost:9001';
///export const API_TOPIC_SERVICE = 'http://localhost:9002';
export const API_EXAM_SERVICE = 'http://localhost:9003';
export const API_KEY = " https://eduapi.bizofficer.in"

function getAPIURL(){
    let url;
    switch(window.location.host) {
      case 'admin.elearning.com':
        url = 'https://api1.elearning.com';
        break;
      case 'adminuat.elearning.com':
        url = 'https://api.elearning.com';
        break;
      default:
        url = 'http://localhost:9001';
        //url = 'https://api.elearning.com';
    }
    return url;
}